import { connect } from 'react-redux'
import LandingPageView from './LandingPageView'

import {
} from '../actions/uiActions'

import {
  locationSearchQuerySelector,
  locationSearchHasFocusSelector,
} from '../reducers/uiReducer'

import {
  findAndSelectClosestTideStation,
} from '../actions/userLocationActions'

import {
  userLocationSelector,
} from '../reducers/userLocationReducer'






// ====================
// = Connect mappings =
// ====================

const mapStateToProps = (state) => {
  return {
    locationSearchHasFocus: locationSearchQuerySelector(state).length !== 0
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    findUserLocation: () => {
      dispatch(findAndSelectClosestTideStation())
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LandingPageView)



// WEBPACK FOOTER //
// ./src/components/LandingPage.js